import { registerLocaleData } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import localeEs from "@angular/common/locales/es";
import { ErrorHandler, LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Camera } from "@ionic-native/camera";
import { Firebase } from "@ionic-native/firebase";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { IonicStorageModule, Storage } from "@ionic/storage";
import {
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { TranslateMessageFormatCompiler } from "ngx-translate-messageformat-compiler";
import { environment } from "../environments/environment";
import { MyApp } from "./app.component";
import { ComponentsModule } from "./components/components.module";
import { Items } from "./mocks/providers/items";
import { BuyVouchersPage } from "./pages/buy-vouchers/buy-vouchers";
import { BuyVouchersPageModule } from "./pages/buy-vouchers/buy-vouchers.module";
import { RequestTermsAcceptedPage } from "./pages/request-terms-accepted/request-terms-accepted";
import { TrainingDetailPage } from "./pages/training-detail/training-detail";
import { TrainingDetailPageModule } from "./pages/training-detail/training-detail.module";
import { TrainingsPageModule } from "./pages/trainings/trainings.module";
import { VouchersPage } from "./pages/vouchers/vouchers";
import { VouchersPageModule } from "./pages/vouchers/vouchers.module";
import { Api, FCM, Settings, User } from "./providers";

// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export function provideSettings(storage: Storage) {
  /**
   * The Settings provider takes a set of default settings for your app.
   *
   * You can add new settings options at any time. Once the settings are saved,
   * these values will not overwrite the saved values (this can be done manually if desired).
   */
  return new Settings(storage, {
    token: false,
  });
}

registerLocaleData(localeEs);

@NgModule({
  declarations: [MyApp, RequestTermsAcceptedPage],
  imports: [
    BrowserModule,
    HttpClientModule,
    ComponentsModule,
    VouchersPageModule,
    BuyVouchersPageModule,
    TrainingsPageModule,
    TrainingDetailPageModule,
    TranslateModule.forRoot({
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    IonicModule.forRoot(MyApp, {
      scrollPadding: false,
    }),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    RequestTermsAcceptedPage,
    VouchersPage,
    BuyVouchersPage,
    TrainingDetailPage,
  ],
  providers: [
    Api,
    Items,
    User,
    FCM,
    Camera,
    SplashScreen,
    StatusBar,
    { provide: LOCALE_ID, useValue: environment.defaultLanguage },
    { provide: Settings, useFactory: provideSettings, deps: [Storage] },
    // Keep this to enable Ionic's runtime error handling during development
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Firebase,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts